import Button from "@app/sharedComponents/Button/Button";
import { ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { X } from '@sharedComponents/Icons';

const AccountOpeningInfo = ({lienMarkingFee,accountOpeningFee,processingFee,gstOnProcessingFee,stampDutyFee,closeBottomSheet}) =>{
    return(
        <ThemedView p="lg">
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center" mb="2xl">
                <ThemedText variant="h5s" color="text-primary">Account opening fee</ThemedText>
            </ThemedView>
            <ThemedView p="sm" backgroundColor="bg-fill-info" borderRadius="sm" mb="lg">
                <ThemedText variant="b4r" color='text-primary'>
                This is a one-time fee. It won't apply on any future withdrawals.
                </ThemedText>                
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="lg"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    Processing fee
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(processingFee)}
                </ThemedText>
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="lg"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    18% GST on processing fee
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(gstOnProcessingFee)}
                </ThemedText>
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="lg"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    Stamp duty fee
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(stampDutyFee)}
                </ThemedText>
            </ThemedView>
            {lienMarkingFee&& <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="lg"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    Lien marking
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(lienMarkingFee)}
                </ThemedText>
            </ThemedView>}
            <ThemedView height={1} backgroundColor="border-secondary" width={"100%"} mb="lg" />
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="2xl"
                >
                <ThemedText variant="b3s" color='text-primary'>
                    Account opening fee
                </ThemedText>
                <ThemedText variant="b3s" color='text-primary'>
                    ₹{formatIndianCurrency(accountOpeningFee)}
                </ThemedText>
            </ThemedView>
            <Button label="Ok, got it!" type="SOLID" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}

export default AccountOpeningInfo;